import { browserRouter } from 'prouter';
import { Do } from './utils/fp';

const router = Do(() => {
  const { use, listen } = browserRouter();

  return {
    route: use,
    exec: listen
  };
});

export { router };
